import { useRouter } from 'next/router';
import {
  Bar,
  BarChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import MethodologyAnchor from '../MethodologyAnchor';
import { StyledRecharts } from './Recharts.styled';

const GenderSalaryByRole: React.FC = () => {
  const { locale } = useRouter();

  const dataEN = [
    {
      role: 'Backend Developer',
      Men: 43.55142526964561,
      Women: 35.06880733944954
    },
    {
      role: 'Full-stack Developer',
      Men: 41.11195492405684,
      Women: 33.14545454545454
    },
    {
      role: 'Frontend Developer',
      Men: 38.06236017897091,
      Women: 30.42138364779874
    },
    {
      role: 'Mobile Developer',
      Men: 42.695595854922274,
      Women: 36.88157894736842
    },
    {
      role: 'Software Architect',
      Men: 54.55178907721281,
      Women: 50.03448275862069
    },
    {
      role: 'DevOps, Infrastructure & SRE',
      Men: 50.48601398601398,
      Women: 43.410714285714285
    },
    { role: 'SysAdmin', Men: 39.703125, Women: 38.375 },
    { role: 'Brand Design', Men: 39.395348837209305, Women: 31.95 },
    {
      role: 'Product Manager',
      Men: 55.49312714776632,
      Women: 46.25568181818181
    },
    {
      role: 'Data Analysis & BI',
      Men: 42.028517110266165,
      Women: 38.40425531914894
    },
    {
      role: 'QA & Testing Engineer',
      Men: 41.729729729729726,
      Women: 36.38888888888889
    },
    {
      role: 'Project & Delivery Manager',
      Men: 55.48470588235294,
      Women: 45.01456310679612
    },
    {
      role: 'Data Scientist',
      Men: 42.22931034482759,
      Women: 38.644444444444446
    },
    {
      role: 'Data Engineer',
      Men: 46.73150684931507,
      Women: 44.7962962962963
    },
    {
      role: 'Engineering Manager',
      Men: 62.71321695760598,
      Women: 50.945945945945944
    },
    {
      role: 'Tech Lead',
      Men: 58.80731364275668,
      Women: 54.85294117647059
    }
  ].sort((a, b) => (a.Women > b.Women ? -1 : 1));

  const dataES = [
    {
      role: 'Backend Developer',
      Hombres: 43.55142526964561,
      Mujeres: 35.06880733944954
    },
    {
      role: 'Full-stack Developer',
      Hombres: 41.11195492405684,
      Mujeres: 33.14545454545454
    },
    {
      role: 'Frontend Developer',
      Hombres: 38.06236017897091,
      Mujeres: 30.42138364779874
    },
    {
      role: 'Mobile Developer',
      Hombres: 42.695595854922274,
      Mujeres: 36.88157894736842
    },
    {
      role: 'Software Architect',
      Hombres: 54.55178907721281,
      Mujeres: 50.03448275862069
    },
    {
      role: 'DevOps, Infrastructure & SRE',
      Hombres: 50.48601398601398,
      Mujeres: 43.410714285714285
    },
    { role: 'SysAdmin', Hombres: 39.703125, Mujeres: 38.375 },
    { role: 'Brand Design', Hombres: 39.395348837209305, Mujeres: 31.95 },
    {
      role: 'Product Manager',
      Hombres: 55.49312714776632,
      Mujeres: 46.25568181818181
    },
    {
      role: 'Data Analysis & BI',
      Hombres: 42.028517110266165,
      Mujeres: 38.40425531914894
    },
    {
      role: 'QA & Testing Engineer',
      Hombres: 41.729729729729726,
      Mujeres: 36.38888888888889
    },
    {
      role: 'Project & Delivery Manager',
      Hombres: 55.48470588235294,
      Mujeres: 45.01456310679612
    },
    {
      role: 'Data Scientist',
      Hombres: 42.22931034482759,
      Mujeres: 38.644444444444446
    },
    {
      role: 'Data Engineer',
      Hombres: 46.73150684931507,
      Mujeres: 44.7962962962963
    },
    {
      role: 'Engineering Manager',
      Hombres: 62.71321695760598,
      Mujeres: 50.945945945945944
    },
    {
      role: 'Tech Lead',
      Hombres: 58.80731364275668,
      Mujeres: 54.85294117647059
    }
  ].sort((a, b) => (a.Mujeres > b.Mujeres ? -1 : 1));

  const data = locale === 'es' ? dataES : dataEN;
  const womenKey = locale === 'es' ? 'Mujeres' : 'Women';
  const menKey = locale === 'es' ? 'Hombres' : 'Men';

  return (
    <div>
      <StyledRecharts className="gender">
        <ResponsiveContainer height={650}>
          <BarChart data={data}>
            <XAxis
              type="category"
              dataKey="role"
              tickLine={false}
              interval={0}
              angle={-60}
              textAnchor="end"
              height={250}
              axisLine={false}
            />
            <YAxis
              tickLine={false}
              width={60}
              axisLine={false}
              tickMargin={5}
              tickFormatter={(tick) => {
                return `€${tick}K`;
              }}
              padding={{ bottom: 5 }}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{ display: 'none' }}
              separator=": "
              formatter={(value: number) => `€${value.toFixed(1)}K`}
              wrapperClassName="tooltip-x"
            />
            <Legend
              layout="horizontal"
              iconType="square"
              wrapperStyle={{ bottom: -5 }}
            />
            <Bar
              dataKey={womenKey}
              barSize={12}
              radius={5}
              fill="#746FB3"
            ></Bar>
            <Bar dataKey={menKey} barSize={12} radius={5} fill="#1B9D76" />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
      <MethodologyAnchor />
    </div>
  );
};

export default GenderSalaryByRole;
